import { Injectable } from '@angular/core';
import { appsettings } from '../shared/app.settings';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';

@Injectable()
export class ContactService {

    contactUrl = appsettings.rootUrl + 'eu/en/salespoint';

    constructor(private http: HttpClient, private router: Router) { }


    getContact() {
        return this.http.get(this.contactUrl)
            .map((response: Response) => response.json())
    }

    getCustomPages(country: string, language: string) {
        return this.http
            .get(appsettings.rootUrl + country + '/' + language + '/custompage')
            .map(
                (custom) => {
                    return custom;
                });
    }

    getNews(country: string, language: string) {
        return this.http
            .get(appsettings.rootUrl + country + '/' + language + '/news')
            .map(
                (news) => {
                    console.log(appsettings.rootUrl + country + '/' + language + '/news');
                    return news;
                });
    }

    getNewsById(id: number, country: string, language: string) {
        return this.http
            .get(appsettings.rootUrl + country + '/' + language + '/news/' + id)
            .map(
                (newsbyid) => {
                    return newsbyid;
                });
    }
}